import type { Template } from "@/types";

export const SQ_05_H4_V1: Template[] = [
    {
        id: "sq-05-h4v1-01",
        name: "SQ 01 - H4V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h4_v1_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 71, y: 170, width: 575, height: 377, rotation: 0, imageRotation: 0 },
            { id: "2", x: 788, y: 74, width: 280, height: 185, rotation: 0, imageRotation: 0 },
            { id: "3", x: 788, y: 267, width: 280, height: 184, rotation: 0, imageRotation: 0 },
            { id: "4", x: 788, y: 459, width: 280, height: 184, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1075, y: 74, width: 288, height: 569, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h4v1-02",
        name: "SQ 02 - H4V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h4_v1_02.png",
        size: [1434, 717],
        style: {},
        slots: [  
            { id: "1", x: 243, y: 42, width: 230, height: 153, rotation: 0, imageRotation: 0 },
            { id: "2", x: 243, y: 203, width: 230, height: 152, rotation: 0, imageRotation: 0 },
            { id: "3", x: 243, y: 363, width: 230, height: 152, rotation: 0, imageRotation: 0 },
            { id: "4", x: 243, y: 523, width: 230, height: 152, rotation: 0, imageRotation: 0 },
            { id: "5", x: 871, y: 42, width: 414, height: 633, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-05-h4v1-03",
        name: "SQ 03 - H4V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h4_v1_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 68, y: 132, width: 337, height: 223, rotation: 0, imageRotation: 0 },
            { id: "2", x: 68, y: 362, width: 337, height: 223, rotation: 0, imageRotation: 0 },
            { id: "3", x: 473, y: 0, width: 488, height: 719, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1029, y: 132, width: 337, height: 223, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1029, y: 362, width: 337, height: 223, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h4v1-04",
        name: "SQ 04 - H4V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h4_v1_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 43, y: 75, width: 632, height: 422, rotation: 0, imageRotation: 0 },         
            { id: "2", x: 43, y: 504, width: 206, height: 138, rotation: 0, imageRotation: 0 },
            { id: "3", x: 257, y: 504, width: 205, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 470, y: 504, width: 205, height: 138, rotation: 0, imageRotation: 0 },
            { id: "5", x: 883, y: 75, width: 386, height: 567, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h4v1-05",
        name: "SQ 05 - H4V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h4_v1_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 102, y: 75, width: 415, height: 280, rotation: 0, imageRotation: 0 },
            { id: "2", x: 102, y: 362, width: 415, height: 280, rotation: 0, imageRotation: 0 },
            { id: "3", x: 524, y: 75, width: 386, height: 567, rotation: 0, imageRotation: 0 },
            { id: "4", x: 917, y: 75, width: 415, height: 280, rotation: 0, imageRotation: 0 },
            { id: "5", x: 917, y: 362, width: 415, height: 280, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h4v1-06",
        name: "SQ 06 - H4V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h4_v1_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 49, y: 145, width: 625, height: 427, rotation: 0, imageRotation: 0 },
            { id: "2", x: 681, y: 145, width: 421, height: 282, rotation: 0, imageRotation: 0 },
            { id: "3", x: 681, y: 434, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 895, y: 434, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1109, y: 145, width: 276, height: 427, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h4v1-07",
        name: "SQ 07 - H4V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h4_v1_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 48, y: 145, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "2", x: 262, y: 145, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "3", x: 48, y: 290, width: 421, height: 282, rotation: 0, imageRotation: 0 },
            { id: "4", x: 476, y: 145, width: 625, height: 427, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1109, y: 145, width: 276, height: 427, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h4v1-08",
        name: "SQ 08 - H4V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h4_v1_08.png",
        size: [1434, 717],
        style: {},
        slots: [      
            { id: "1", x: 46, y: 150, width: 309, height: 205, rotation: 0, imageRotation: 0 },
            { id: "2", x: 46, y: 363, width: 309, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 363, y: 150, width: 308, height: 205, rotation: 0, imageRotation: 0 },
            { id: "4", x: 363, y: 363, width: 308, height: 204, rotation: 0, imageRotation: 0 },
            { id: "5", x: 869, y: 57, width: 414, height: 603, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-05-h4v1-09",
        name: "SQ 09 - H4V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h4_v1_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 273, width: 240, height: 171, rotation: 0, imageRotation: 0 },
            { id: "2", x: 247, y: 273, width: 254, height: 171, rotation: 0, imageRotation: 0 },
            { id: "3", x: 508, y: 46, width: 418, height: 625, rotation: 0, imageRotation: 0 },
            { id: "4", x: 933, y: 273, width: 254, height: 171, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1194, y: 273, width: 240, height: 171, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-05-h4v1-10",
        name: "SQ 10 - H4V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-05-h4_v1_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 214, y: 46, width: 309, height: 204, rotation: 0, imageRotation: 0 },
            { id: "2", x: 46, y: 257, width: 309, height: 203, rotation: 0, imageRotation: 0 },
            { id: "3", x: 362, y: 257, width: 309, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 208, y: 467, width: 309, height: 204, rotation: 0, imageRotation: 0 },
            { id: "5", x: 866, y: 46, width: 419, height: 625, rotation: 0, imageRotation: 0 }
        ],
    },

];

